import {Component} from '@angular/core';
import {AnalyticsTracker} from '../../utils/AnalyticsTracker';
import {Router} from '@angular/router';
import {ProfileType} from '../../model/profile-type.model';

@Component({
    selector: 'app-campaign',
    templateUrl: './campaign.component.html',
    styleUrls: ['./campaign-banner.component.css', './campaign.component.css']
})
export class CampaignComponent {
    public analyticsTracker: AnalyticsTracker;
    ProfileType = ProfileType;

    constructor(analyticsTracker: AnalyticsTracker, private route: Router) {
        this.analyticsTracker = analyticsTracker;
    }

    getCurrentUrl(): string {
        return this.route.url.split('#')[0];
    }
}
